document.addEventListener('DOMContentLoaded', function () {  

  const closeIconElement = document.querySelector('.close-icon-img')
  const closeIconSrc = closeIconElement ? closeIconElement.src : '';

  const createSplide = ( divId, imageList ) => {
    const carousel = document.createElement('section');
    carousel.id = divId;
    carousel.className = 'splide';
    carousel.setAttribute('aria-label', 'Zoom gallery');

    const trackDiv = document.createElement('div');
    trackDiv.className = 'splide__track';

    const slideList = document.createElement('ul');
    slideList.className = 'splide__list';

    imageList.forEach(img => {
      const slideItem = document.createElement('li');
      slideItem.className = 'splide__slide';

      const image= document.createElement('img');
      image.src = img.src;
      image.alt = '';

      slideItem.appendChild(image);
      slideList.appendChild(slideItem);
    });

    trackDiv.appendChild(slideList);
    carousel.appendChild(trackDiv);

    return carousel;
  };

  const closeZoomGallery = ( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails ) => {
    document.body.classList.remove('mainProduct-zoomGallery-open');
    setTimeout(function() {
      destroySplide(zoomCarouselSP, zoomCarousel);
      destroySplide(zoomThumbnailsSP, zoomThumbnails);
      document.querySelector('.mainProduct-zoomGallery').remove();
    }, 300);
  }

  const destroySplide = ( splideInstance, container ) => {
    if ( splideInstance && splideInstance.destroy ) {
      splideInstance.destroy();
    }
    container.remove();
  }

  const initZoom = ( imageList, index ) => {
    console.log('=========================initZoom', index);
    const zoomGalleryDiv = document.createElement('div');
    zoomGalleryDiv.className = 'mainProduct-zoomGallery';
    document.body.appendChild(zoomGalleryDiv);

    const closeIcon = document.createElement('img');
    closeIcon.src = closeIconSrc;
    closeIcon.alt = 'Close';
    closeIcon.className = 'mainProduct-zoomGallery-close';
    zoomGalleryDiv.appendChild(closeIcon);

    const zoomCarousel = createSplide('zoom-carousel', imageList);
    const zoomThumbnails = createSplide('zoom-carousel-thumbs', imageList);

    zoomGalleryDiv.appendChild(zoomCarousel);
    zoomGalleryDiv.appendChild(zoomThumbnails);

    const windowHeight = window.innerHeight;
    const mainGalleryHeight = (windowHeight * 0.75) + 'px'; 

    var zoomCarouselSP = new Splide( zoomCarousel, {
      type: 'slide',
      pagination: false,
      arrows    : true,
      height: mainGalleryHeight,
      width: mainGalleryHeight,
      start: index || 0,
    } );
  
    var zoomThumbnailsSP = new Splide( zoomThumbnails, {
      perPage     : 6,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      isNavigation: true,
      arrows    : false,
      width: mainGalleryHeight,
      start: index || 0,
    } );
  
    zoomCarouselSP.sync( zoomThumbnailsSP );
    zoomCarouselSP.mount();
    zoomThumbnailsSP.mount();

    document.body.classList.add('mainProduct-zoomGallery-open');
    setTimeout(function() {
      document.body.classList.add('mainProduct-zoomGallery-splideReady');
      setTimeout(function() {
        
        zoomCarouselSP.go(index + 1);
        zoomThumbnailsSP.go(index);
      }, 500);
    }, 100);

    closeIcon.addEventListener('click', function(){
      closeZoomGallery( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails );
    });

    zoomGalleryDiv.addEventListener('click', function(e) {
      if ( e.target.classList.contains('mainProduct-zoomGallery') ) {
        closeZoomGallery( zoomCarouselSP, zoomThumbnailsSP, zoomCarousel, zoomThumbnails );
      }
    });
  };

  const galleryImages = document.querySelectorAll('.mainProduct-gallery img');
  if ( galleryImages.length ) {
    galleryImages.forEach(img => {
      img.addEventListener('click', function() {
        const $parent = this.closest('.splide__list');
        const $slide = this.closest('.splide__slide');
        const index = Array.from($parent.children).indexOf($slide);
        const imageList = $parent.querySelectorAll('img');
        const windowWidth = window.innerWidth;
        if ( windowWidth > 900 ) initZoom(imageList, index);
        
      });
    });
  }

});